import React from 'react';
import FilterConfigurationPublishButton from '../components/FilterConfigurationPublishButton';

const Sidebar = () => {
  return <FilterConfigurationPublishButton />;
};

export default Sidebar;
